export const HANDSET_LIST = 'HANDSET_LIST';
export const HANDSET_LIST_SUCCESS = 'HANDSET_LIST_LIST_SUCCESS';
export const HANDSET_LIST_ERROR = 'HANDSET_LIST_LIST_ERROR';

export const HANDSET_LIST_DETAILS = 'HANDSET_LIST_DETAILS';
export const HANDSET_LIST_DETAILS_SUCCESS = 'HANDSET_LIST_DETAILS_SUCCESS';
export const HANDSET_LIST_DETAILS_ERROR = 'HANDSET_LIST_DETAILS_ERROR';

export const ADD_HANDSET_LIST_DETAILS = 'ADD_HANDSET_LIST_DETAILS';
export const ADD_HANDSET_LIST_DETAILS_SUCCESS = 'ADD_HANDSET_LIST_DETAILS_SUCCESS';
export const ADD_HANDSET_LIST_DETAILS_ERROR = 'ADD_HANDSET_LIST_DETAILS_ERROR';

export const UPDATE_HANDSET_LIST = 'UPDATE_HANDSET_LIST';
export const UPDATE_HANDSET_LIST_SUCCESS = 'UPDATE_HANDSET_LIST_SUCCESS';
export const UPDATE_HANDSET_LIST_ERROR = 'UPDATE_HANDSET_LIST_ERROR';

export const DELETE_HANDSET_LIST = 'DELETE_HANDSET_LIST';
export const DELETE_HANDSET_LIST_SUCCESS = 'DELETE_HANDSET_LIST_SUCCESS';
export const DELETE_HANDSET_LIST_ERROR = 'DELETE_HANDSET_LIST_ERROR';

export const ASSIGN_USERS_LIST = 'ASSIGN_USERS_LIST';
export const ASSIGN_USERS_LIST_SUCCESS = 'ASSIGN_USERS_LIST_SUCCESS';
export const ASSIGN_USERS_LIST_ERROR = 'ASSIGN_USERS_LIST_ERROR';
